import { IHoliday } from "../holidayTypes";

  export const BelgiumHolidays: { [key: string]: IHoliday } = {
    // 2024
    "2024-01-01": { title: "Nieuwjaar", type: "HOLIDAY" },
    "2024-04-01": { title: "Paasmaandag", type: "HOLIDAY" },
    "2024-05-01": { title: "Dag van de Arbeid", type: "HOLIDAY" },
    "2024-05-09": { title: "Hemelvaart", type: "HOLIDAY" },
    "2024-05-20": { title: "Pinkstermaandag", type: "HOLIDAY" },
    "2024-07-21": { title: "Nationale Feestdag", type: "HOLIDAY" },
    "2024-08-15": { title: "Onze-Lieve-Vrouw-Hemelvaart", type: "HOLIDAY" },
    "2024-11-01": { title: "Allerheiligen", type: "HOLIDAY" },
    "2024-11-11": { title: "Wapenstilstand", type: "HOLIDAY" },
    "2024-12-25": { title: "Kerstmis", type: "HOLIDAY" },

    // 2025
    "2025-01-01": { title: "Nieuwjaar", type: "HOLIDAY" },
    "2025-01-06": { title: "Driekoningen", type: "SPECIAL_DAY" },
    "2025-02-14": { title: "Valentijnsdag", type: "SPECIAL_DAY" },
    "2025-04-18": { title: "Goede Vrijdag", type: "SPECIAL_DAY" },
    "2025-04-20": { title: "Pasen", type: "SPECIAL_DAY" },
    "2025-04-21": { title: "Paasmaandag", type: "HOLIDAY" },
    "2025-05-01": { title: "Dag van de Arbeid", type: "HOLIDAY" },
    "2025-05-29": { title: "Hemelvaart", type: "HOLIDAY" },
    "2025-06-09": { title: "Pinkstermaandag", type: "HOLIDAY" },
    "2025-07-21": { title: "Nationale Feestdag", type: "HOLIDAY" },
    "2025-08-15": { title: "Onze-Lieve-Vrouw-Hemelvaart", type: "HOLIDAY" },
    "2025-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
    "2025-11-01": { title: "Allerheiligen", type: "HOLIDAY" },
    "2025-11-02": { title: "Allerzielen", type: "SPECIAL_DAY" },
    "2025-11-11": { title: "Wapenstilstand", type: "HOLIDAY" },
    "2025-12-06": { title: "Sinterklaas", type: "SPECIAL_DAY" },
    "2025-12-25": { title: "Kerstmis", type: "HOLIDAY" },
    "2025-12-31": { title: "Oudejaarsavond", type: "SPECIAL_DAY" },

    // 2026
    "2026-01-01": { title: "Nieuwjaar", type: "HOLIDAY" },
    "2026-01-06": { title: "Driekoningen", type: "SPECIAL_DAY" },
    "2026-02-14": { title: "Valentijnsdag", type: "SPECIAL_DAY" },
    "2026-04-03": { title: "Goede Vrijdag", type: "SPECIAL_DAY" },
    "2026-04-05": { title: "Pasen", type: "SPECIAL_DAY" },
    "2026-04-06": { title: "Paasmaandag", type: "HOLIDAY" },
    "2026-05-01": { title: "Dag van de Arbeid", type: "HOLIDAY" },
    "2026-05-14": { title: "Hemelvaart", type: "HOLIDAY" },
    "2026-05-24": { title: "Pinksteren", type: "SPECIAL_DAY" },
    "2026-05-25": { title: "Pinkstermaandag", type: "HOLIDAY" },
    "2026-07-11": { title: "Feest van de Vlaamse Gemeenschap", type: "SPECIAL_DAY" },
    "2026-07-21": { title: "Nationale Feestdag", type: "HOLIDAY" },
    "2026-08-15": { title: "Onze-Lieve-Vrouw-Hemelvaart", type: "HOLIDAY" },
    "2026-09-27": { title: "Feest van de Franse Gemeenschap", type: "SPECIAL_DAY" },
    "2026-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
    "2026-11-01": { title: "Allerheiligen", type: "HOLIDAY" },
    "2026-11-02": { title: "Allerzielen", type: "SPECIAL_DAY" },
    "2026-11-11": { title: "Wapenstilstand", type: "HOLIDAY" },
    "2026-12-06": { title: "Sinterklaas", type: "SPECIAL_DAY" },
    "2026-12-25": { title: "Kerstmis", type: "HOLIDAY" },
    "2026-12-31": { title: "Oudejaarsavond", type: "SPECIAL_DAY" },

    // 2027
    "2027-01-01": { title: "Nieuwjaar", type: "HOLIDAY" },
    "2027-01-06": { title: "Driekoningen", type: "SPECIAL_DAY" },
    "2027-02-14": { title: "Valentijnsdag", type: "SPECIAL_DAY" },
    "2027-03-26": { title: "Goede Vrijdag", type: "SPECIAL_DAY" },
    "2027-03-28": { title: "Pasen", type: "SPECIAL_DAY" },
    "2027-03-29": { title: "Paasmaandag", type: "HOLIDAY" },
    "2027-05-01": { title: "Dag van de Arbeid", type: "HOLIDAY" },
    "2027-05-06": { title: "Hemelvaart", type: "HOLIDAY" },
    "2027-05-16": { title: "Pinksteren", type: "SPECIAL_DAY" },
    "2027-05-17": { title: "Pinkstermaandag", type: "HOLIDAY" },
    "2027-07-11": { title: "Feest van de Vlaamse Gemeenschap", type: "SPECIAL_DAY" },
    "2027-07-21": { title: "Nationale Feestdag", type: "HOLIDAY" },
    "2027-08-15": { title: "Onze-Lieve-Vrouw-Hemelvaart", type: "HOLIDAY" },
    "2027-09-27": { title: "Feest van de Franse Gemeenschap", type: "SPECIAL_DAY" },
    "2027-10-31": { title: "Halloween", type: "SPECIAL_DAY" },
    "2027-11-01": { title: "Allerheiligen", type: "HOLIDAY" },
    "2027-11-02": { title: "Allerzielen", type: "SPECIAL_DAY" },
    "2027-11-11": { title: "Wapenstilstand", type: "HOLIDAY" },
    "2027-12-06": { title: "Sinterklaas", type: "SPECIAL_DAY" },
    "2027-12-25": { title: "Kerstmis", type: "HOLIDAY" },
    "2027-12-31": { title: "Oudejaarsavond", type: "SPECIAL_DAY" },
  };




// WEBPACK FOOTER //
// ./src/constants/holidays/europe/belgiumHolidays.ts